/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaInstagram16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.145 4.852a.96.96 0 1 1 0-1.92.96.96 0 0 1 0 1.92M8 12c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m4 10H4c-2.056 0-4-1.944-4-4V4c0-2.056 1.944-4 4-4h8c2.056 0 4 1.944 4 4v8c0 2.056-1.944 4-4 4M4 2c-.935 0-2 1.065-2 2v8c0 .953 1.047 2 2 2h8c.935 0 2-1.065 2-2V4c0-.935-1.065-2-2-2z"
    />
  </svg>
);

export const __descriptor_SocialMediaInstagram = {
  name: "SocialMediaInstagram",
  instances: [{ size: 16, Component: SocialMediaInstagram16 }],
} as const;
